import BaseError from "./BaseError";

class HttpRequestError extends BaseError {
  constructor(public message: string) {
    super();
  }
}

export default HttpRequestError;
